import React from "react";
import RoutesComponent from "./routes/RoutesComponent";
import 'react-range-slider-input/dist/style.css';

const App = () => {
  return (
    <RoutesComponent />
  );
};

export default App;
